import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createSlots as _createSlots, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-arrow-left text-md cursor-pointer" }, null, -1);
const _hoisted_2 = [
    _hoisted_1
];
const _hoisted_3 = { class: "w-full" };
const _hoisted_4 = { class: "flex flex-row" };
const _hoisted_5 = {
    key: 0,
    class: "text-base md:text-xl lg:text-3xl truncate"
};
const _hoisted_6 = { class: "pl-1 md:text-xl lg:text-3xl" };
const _hoisted_7 = { class: "ml-1 flex flex-row items-center" };
const _hoisted_8 = { class: "block fas fa-crown text-xs ml-2" };
const _hoisted_9 = { class: "flex flex-col w-full h-full overflow-hidden p-2" };
const _hoisted_10 = { class: "flex flex-row justify-between mb-2 items-center" };
const _hoisted_11 = { class: "hidden md:block" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-plus mr-2" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("em", { class: "block md:hidden fas fa-plus" }, null, -1);
const _hoisted_14 = { class: "flex flex-row items-center pl-2" };
const _hoisted_15 = { class: "pl-3 font-bold" };
const _hoisted_16 = { class: "flex flex-row items-center pl-2" };
const _hoisted_17 = { class: "flex flex-row items-center hidden md:flex" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1 max-w-xs align-middle" }, [
    /*#__PURE__*/ _createElementVNode("em", { class: "fa-solid fa-user-gear fa-fw" })
], -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1 max-w-xs align-middle" }, [
    /*#__PURE__*/ _createElementVNode("em", { class: "fa-solid fa-user-gear fa-fw" })
], -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1 max-w-xs align-middle" }, [
    /*#__PURE__*/ _createElementVNode("em", { class: "fa-solid fa-ban fa-fw" })
], -1);
export function render(_ctx, _cache) {
    const _component_work_space_dropdown = _resolveComponent("work-space-dropdown");
    const _component_search_bar = _resolveComponent("search-bar");
    const _component_Button = _resolveComponent("Button");
    const _component_tooltip = _resolveComponent("tooltip");
    const _component_avatar = _resolveComponent("avatar");
    const _component_MenuItem = _resolveComponent("MenuItem");
    const _component_category_popover = _resolveComponent("category-popover");
    const _component_user_navigation_icon = _resolveComponent("user-navigation-icon");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_Table = _resolveComponent("Table");
    const _component_tab_layout = _resolveComponent("tab-layout");
    const _component_confirm_modal = _resolveComponent("confirm-modal");
    const _component_invitation_single_vault_modal = _resolveComponent("invitation-single-vault-modal");
    const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_tab_layout, null, _createSlots({
            title: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_work_space_dropdown, null, {
                            selectedItem: _withCtx(() => [
                                (_ctx.selectedWorkspace)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedWorkspace.name), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_6, "- " + _toDisplayString(_ctx.$t('user.users')), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                                [_vShow, _ctx.$route.meta.isAdmin]
                            ])
                        ])
                    ])
                ])
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_search_bar, {
                            class: "flex-grow",
                            searchValue: _ctx.userSearch,
                            "onUpdate:searchValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.userSearch) = $event))
                        }, null, 8, ["searchValue"]),
                        (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.create }) && _ctx.isAppPreregistrationEnabled)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                class: "ml-2 h-10",
                                colored: "",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showInvitationSingleVaultModal = true))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                        _hoisted_12,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.new')), 1)
                                    ]),
                                    _hoisted_13
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_Table, {
                        headers: _ctx.headers,
                        "default-sort": _ctx.sortedField,
                        "onUpdate:default-sort": _cache[3] || (_cache[3] = ($event) => ((_ctx.sortedField) = $event)),
                        "backend-pagination-sorting": "",
                        onSortChanged: _ctx.sortUsers,
                        data: _ctx.users,
                        emptyMessage: _ctx.$t('filter.usersNotFound'),
                        "is-loading": _ctx.isLoading
                    }, {
                        "header-role": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('tables.headers.userRoles')) + " ", 1),
                            _createVNode(_component_tooltip, {
                                class: "normal-case",
                                text: _ctx.generateVaultRoleExplanation()
                            }, null, 8, ["text"])
                        ]),
                        "data-username": _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_avatar, {
                                    rounded: "",
                                    class: "hidden md:block h-12 w-12",
                                    "round-size": "full",
                                    src: `https://picsum.photos/seed/${row.id}/300/300`
                                }, null, 8, ["src"]),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(row.username), 1)
                            ])
                        ]),
                        "data-vaults": _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.spaces, (space) => {
                                        return (_openBlock(), _createBlock(_component_avatar, {
                                            key: space.id,
                                            class: "h-8 w-8",
                                            src: `https://picsum.photos/seed/${space.id}/300/300`,
                                            "round-size": "full h-8 w-8"
                                        }, null, 8, ["src"]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        "data-role": _withCtx(({ row }) => [
                            _createVNode(_component_tooltip, {
                                text: [
                                    {
                                        title: _ctx.translate(`vault.roles.${row.vaultRole}`),
                                        explanation: _ctx.translate(`explanation.${row.vaultRole}`),
                                    },
                                ]
                            }, {
                                source: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`vault.roles.${row.vaultRole}`)), 1)
                                ]),
                                _: 2
                            }, 1032, ["text"])
                        ]),
                        "data-actions": _withCtx(({ row }) => [
                            (((row.id === _ctx.currentUser.id && _ctx.config.env.canRevokeYourSelfFromVault) || (row.id !== _ctx.currentUser.id && _ctx.config.env.isVaultAdminRolePromotionDemotionEnabled)) &&
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.edit }) ||
                                    _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.delete })))
                                ? (_openBlock(), _createBlock(_component_category_popover, {
                                    key: 0,
                                    "custom-classes": "mt-8",
                                    class: "z-60 flex w-full justify-end"
                                }, {
                                    items: _withCtx(() => [
                                        (row.id !== _ctx.currentUser.id &&
                                            _ctx.config.env.isVaultAdminRolePromotionDemotionEnabled &&
                                            _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.edit }) &&
                                            !!_ctx.findNewPromotionRole(row.vaultRole, _ctx.PromotionType.PROMOTE))
                                            ? (_openBlock(), _createBlock(_component_MenuItem, {
                                                key: 0,
                                                class: "text-blue-400 cursor-pointer",
                                                onClick: _withModifiers(($event) => (_ctx.openConfirmation({ item: row, type: _ctx.Type.PROMOTE })), ["exact"])
                                            }, {
                                                default: _withCtx(({ active }) => [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["opacity-80", { 'opacity-100': active }])
                                                    }, [
                                                        _hoisted_18,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('user.promote.promote')) + " " + _toDisplayString(_ctx.$t('vault.roles.' + _ctx.findNewPromotionRole(row.vaultRole, _ctx.PromotionType.PROMOTE))), 1)
                                                    ], 2)
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                        (row.id !== _ctx.currentUser.id &&
                                            _ctx.config.env.isVaultAdminRolePromotionDemotionEnabled &&
                                            _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.edit }) &&
                                            !!_ctx.findNewPromotionRole(row.vaultRole, _ctx.PromotionType.DEMOTE))
                                            ? (_openBlock(), _createBlock(_component_MenuItem, {
                                                key: 1,
                                                class: "text-blue-400 cursor-pointer",
                                                onClick: _withModifiers(($event) => (_ctx.openConfirmation({ item: row, type: _ctx.Type.DEMOTE })), ["exact"])
                                            }, {
                                                default: _withCtx(({ active }) => [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["opacity-80", { 'opacity-100': active }])
                                                    }, [
                                                        _hoisted_19,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('user.demote.demote')) + " " + _toDisplayString(_ctx.$t('vault.roles.' + _ctx.findNewPromotionRole(row.vaultRole, _ctx.PromotionType.DEMOTE))), 1)
                                                    ], 2)
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                        (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.delete }) &&
                                            (row.id !== _ctx.currentUser.id || (_ctx.config.env.canRevokeYourSelfFromVault && row.id === _ctx.currentUser.id)))
                                            ? (_openBlock(), _createBlock(_component_MenuItem, {
                                                key: 2,
                                                class: "text-red-400 cursor-pointer",
                                                onClick: _withModifiers(($event) => (_ctx.openConfirmation({ item: row, type: _ctx.Type.REVOKE })), ["exact"])
                                            }, {
                                                default: _withCtx(({ active }) => [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["opacity-80", { 'opacity-100': active }])
                                                    }, [
                                                        _hoisted_20,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('user.revoke.revoke')), 1)
                                                    ], 2)
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1024))
                                : _createCommentVNode("", true)
                        ]),
                        tableEmptyState: _withCtx(() => [
                            _createVNode(_component_empty_table_state, null, _createSlots({
                                icon: _withCtx(() => [
                                    _createVNode(_component_user_navigation_icon, { class: "h-8 w-8 mx-auto text-gray-400" })
                                ]),
                                header: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('filter.usersNotFound')), 1)
                                ]),
                                _: 2
                            }, [
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.users, operation: _ctx.AccessOperations.create }) && _ctx.userSearch === '')
                                    ? {
                                        name: "content",
                                        fn: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('filter.userInviteMessage')), 1)
                                        ])
                                    }
                                    : undefined
                            ]), 1024)
                        ]),
                        _: 1
                    }, 8, ["headers", "default-sort", "onSortChanged", "data", "emptyMessage", "is-loading"])), [
                        [_directive_infinite_scroll, {
                                trigger: _ctx.getMoreUsers,
                                options: { limit: 15 },
                            }]
                    ])
                ])
            ]),
            _: 2
        }, [
            (_ctx.isAdmin)
                ? {
                    name: "leftButton",
                    fn: _withCtx(() => [
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'AdminVaultsOverview' })))
                        }, _hoisted_2)
                    ])
                }
                : undefined
        ]), 1024),
        (_ctx.showConfirmation)
            ? (_openBlock(), _createBlock(_component_confirm_modal, {
                key: 0,
                show: _ctx.showConfirmation,
                "onUpdate:show": _cache[4] || (_cache[4] = ($event) => ((_ctx.showConfirmation) = $event)),
                onCancel: _ctx.closeConfirmation,
                onConfirm: _ctx.handleConfirmation,
                type: _ctx.confirmationData.type
            }, null, 8, ["show", "onCancel", "onConfirm", "type"]))
            : _createCommentVNode("", true),
        (_ctx.showInvitationSingleVaultModal)
            ? (_openBlock(), _createBlock(_component_invitation_single_vault_modal, {
                key: 1,
                onAddUser: _ctx.addUser,
                "selected-space": _ctx.selectedWorkspace,
                show: _ctx.showInvitationSingleVaultModal,
                "onUpdate:show": _cache[5] || (_cache[5] = ($event) => ((_ctx.showInvitationSingleVaultModal) = $event))
            }, null, 8, ["onAddUser", "selected-space", "show"]))
            : _createCommentVNode("", true)
    ], 64));
}
